import { useMemo } from "react";
import StorageFactory from "../../../Util/StorageFactory";
import {
  SESSION_ADMIN_SCOPE_KEY,
  SESSION_ADMIN_TYPE_KEY,
  SESSION_IS_SUPER_ADMIN_KEY,
  SESSION_USER_TYPE_KEY,
} from "../../../Util/VMConstants";

/**
 * Admin panel session: SuperAdmin (full access) vs subAdmin (city-scoped).
 */
export function useAdminPanel() {
  const session = useMemo(() => new StorageFactory("session"), []);

  const adminType =
    session.get(SESSION_ADMIN_TYPE_KEY) ||
    (session.get(SESSION_USER_TYPE_KEY) === "subAdmin" ? "subAdmin" : "SuperAdmin");

  const adminScope = session.get(SESSION_ADMIN_SCOPE_KEY) || null;
  const isSubAdmin = adminType === "subAdmin";
  const isSuperAdmin = adminType === "SuperAdmin" || session.get(SESSION_IS_SUPER_ADMIN_KEY) === true;
  const canManageAdmins = !isSubAdmin;
  const locationLocked = isSubAdmin && Boolean(adminScope?.country || adminScope?.state || adminScope?.city);

  return {
    adminType,
    adminScope,
    isSubAdmin,
    isSuperAdmin,
    canManageAdmins,
    locationLocked,
  };
}
